import {
  AbstractLogo,
  AbstractLogoCircle,
  AbstractLogoCircleMonochrome,
  AbstractLogoSquare,
  ApeLogo,
  ApeLogoCircle,
  ApeLogoCircleMonochrome,
  ApeLogoSquare,
  ArbitrumLogo,
  ArbitrumLogoCircle,
  ArbitrumLogoCircleMonochrome,
  ArbitrumLogoSquare,
  ArbitrumNovaLogo,
  ArbitrumNovaLogoCircle,
  ArbitrumNovaLogoCircleMonochrome,
  ArbitrumNovaLogoSquare,
  AvalancheLogo,
  AvalancheLogoCircle,
  AvalancheLogoCircleMonochrome,
  AvalancheLogoSquare,
  B3Logo,
  B3LogoCircle,
  B3LogoCircleMonochrome,
  B3LogoSquare,
  BaseLogo,
  BaseLogoCircle,
  BaseLogoCircleMonochrome,
  BaseLogoSquare,
  BeraChainLogo,
  BeraChainLogoCircle,
  BeraChainLogoCircleMonochrome,
  BeraChainLogoSquare,
  BlastLogo,
  BlastLogoCircle,
  BlastLogoCircleMonochrome,
  BlastLogoSquare,
  EthereumLogo,
  EthereumLogoCircle,
  EthereumLogoCircleMonochrome,
  EthereumLogoSquare,
  FlowLogo,
  FlowLogoCircle,
  FlowLogoCircleMonochrome,
  FlowLogoSquare,
  GunzillaLogo,
  GunzillaLogoCircle,
  GunzillaLogoCircleMonochrome,
  GunzillaLogoSquare,
  HyperEVMLogo,
  HyperEVMLogoCircle,
  HyperEVMLogoCircleMonochrome,
  HyperEVMLogoSquare,
  type IconComponent,
  OptimismLogo,
  OptimismLogoCircle,
  OptimismLogoCircleMonochrome,
  OptimismLogoSquare,
  PolygonLogo,
  PolygonLogoCircle,
  PolygonLogoCircleMonochrome,
  PolygonLogoSquare,
  RoninLogo,
  RoninLogoCircle,
  RoninLogoCircleMonochrome,
  RoninLogoSquare,
  SeiLogo,
  SeiLogoCircle,
  SeiLogoCircleMonochrome,
  SeiLogoSquare,
  ShapeLogo,
  ShapeLogoCircle,
  ShapeLogoCircleMonochrome,
  ShapeLogoSquare,
  SolanaLogo,
  SolanaLogoCircle,
  SolanaLogoCircleMonochrome,
  SolanaLogoSquare,
  SomniaLogo,
  SomniaLogoCircle,
  SomniaLogoCircleMonochrome,
  SomniaLogoSquare,
  SoneiumLogo,
  SoneiumLogoCircle,
  SoneiumLogoCircleMonochrome,
  SoneiumLogoSquare,
  UnichainLogo,
  UnichainLogoCircle,
  UnichainLogoCircleMonochrome,
  UnichainLogoSquare,
  ZoraLogo,
  ZoraLogoCircle,
  ZoraLogoCircleMonochrome,
  ZoraLogoSquare,
} from "@opensea/ui-kit/icons"
import type { Chain } from "./queries"

const IDENTIFIER_TO_LOGO = {
  ape_chain: {
    default: ApeLogo,
    circle: ApeLogoCircle,
    circleMonochrome: ApeLogoCircleMonochrome,
    square: ApeLogoSquare,
  },
  ethereum: {
    default: EthereumLogo,
    circle: EthereumLogoCircle,
    circleMonochrome: EthereumLogoCircleMonochrome,
    square: EthereumLogoSquare,
  },
  base: {
    default: BaseLogo,
    circle: BaseLogoCircle,
    circleMonochrome: BaseLogoCircleMonochrome,
    square: BaseLogoSquare,
  },
  b3: {
    default: B3Logo,
    circle: B3LogoCircle,
    circleMonochrome: B3LogoCircleMonochrome,
    square: B3LogoSquare,
  },
  arbitrum: {
    default: ArbitrumLogo,
    circle: ArbitrumLogoCircle,
    circleMonochrome: ArbitrumLogoCircleMonochrome,
    square: ArbitrumLogoSquare,
  },
  arbitrum_nova: {
    default: ArbitrumNovaLogo,
    circle: ArbitrumNovaLogoCircle,
    circleMonochrome: ArbitrumNovaLogoCircleMonochrome,
    square: ArbitrumNovaLogoSquare,
  },
  flow: {
    default: FlowLogo,
    circle: FlowLogoCircle,
    circleMonochrome: FlowLogoCircleMonochrome,
    square: FlowLogoSquare,
  },
  polygon: {
    default: PolygonLogo,
    circle: PolygonLogoCircle,
    circleMonochrome: PolygonLogoCircleMonochrome,
    square: PolygonLogoSquare,
  },
  avalanche: {
    default: AvalancheLogo,
    circle: AvalancheLogoCircle,
    circleMonochrome: AvalancheLogoCircleMonochrome,
    square: AvalancheLogoSquare,
  },
  zora: {
    default: ZoraLogo,
    circle: ZoraLogoCircle,
    circleMonochrome: ZoraLogoCircleMonochrome,
    square: ZoraLogoSquare,
  },
  optimism: {
    default: OptimismLogo,
    circle: OptimismLogoCircle,
    circleMonochrome: OptimismLogoCircleMonochrome,
    square: OptimismLogoSquare,
  },
  blast: {
    default: BlastLogo,
    circle: BlastLogoCircle,
    circleMonochrome: BlastLogoCircleMonochrome,
    square: BlastLogoSquare,
  },
  soneium: {
    default: SoneiumLogo,
    circle: SoneiumLogoCircle,
    circleMonochrome: SoneiumLogoCircleMonochrome,
    square: SoneiumLogoSquare,
  },
  sei: {
    default: SeiLogo,
    circle: SeiLogoCircle,
    circleMonochrome: SeiLogoCircleMonochrome,
    square: SeiLogoSquare,
  },
  bera_chain: {
    default: BeraChainLogo,
    circle: BeraChainLogoCircle,
    circleMonochrome: BeraChainLogoCircleMonochrome,
    square: BeraChainLogoSquare,
  },
  ronin: {
    default: RoninLogo,
    circle: RoninLogoCircle,
    circleMonochrome: RoninLogoCircleMonochrome,
    square: RoninLogoSquare,
  },
  solana: {
    default: SolanaLogo,
    circle: SolanaLogoCircle,
    circleMonochrome: SolanaLogoCircleMonochrome,
    square: SolanaLogoSquare,
  },
  abstract: {
    default: AbstractLogo,
    circle: AbstractLogoCircle,
    circleMonochrome: AbstractLogoCircleMonochrome,
    square: AbstractLogoSquare,
  },
  shape: {
    default: ShapeLogo,
    circle: ShapeLogoCircle,
    circleMonochrome: ShapeLogoCircleMonochrome,
    square: ShapeLogoSquare,
  },
  unichain: {
    default: UnichainLogo,
    circle: UnichainLogoCircle,
    circleMonochrome: UnichainLogoCircleMonochrome,
    square: UnichainLogoSquare,
  },
  gunzilla: {
    default: GunzillaLogo,
    circle: GunzillaLogoCircle,
    circleMonochrome: GunzillaLogoCircleMonochrome,
    square: GunzillaLogoSquare,
  },
  hyperevm: {
    default: HyperEVMLogo,
    circle: HyperEVMLogoCircle,
    circleMonochrome: HyperEVMLogoCircleMonochrome,
    square: HyperEVMLogoSquare,
  },
  somnia: {
    default: SomniaLogo,
    circle: SomniaLogoCircle,
    circleMonochrome: SomniaLogoCircleMonochrome,
    square: SomniaLogoSquare,
  },
} as const

type PredefinedChainIdentifier = keyof typeof IDENTIFIER_TO_LOGO

type GetChainLogoOptions = {
  circle?: boolean
  square?: boolean
  monochrome?: boolean
}

/**
 * Pure function to get chain logo based on identifier and options.
 * Returns either an icon component or an image source URL.
 */
export function getChainLogo(
  identifier: string,
  theme: "light" | "dark",
  chain: Chain | undefined,
  options: GetChainLogoOptions = {},
): { src: string } | { icon: IconComponent } {
  const { circle, square, monochrome } = options

  // Check if this is a predefined chain with icon components
  if (identifier in IDENTIFIER_TO_LOGO) {
    const logos = IDENTIFIER_TO_LOGO[identifier as PredefinedChainIdentifier]

    if (square) {
      return {
        icon: logos.square,
      }
    }

    if (circle) {
      if (monochrome) {
        return {
          icon: logos.circleMonochrome || logos.circle,
        }
      }

      return {
        icon: logos.circle,
      }
    }

    return {
      icon: logos.default,
    }
  }

  // Fallback to chain config logo URLs
  if (chain?.logoLightMode && chain.logoDarkMode) {
    return {
      src:
        theme === "dark" ? chain.logoDarkMode.mono : chain.logoLightMode.mono,
    }
  }

  return { src: "" }
}
